import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-image-viewer',
  template: `
  <ion-content  (click)="dismiss()">
    <div class="viewer">
      <img [src]="url" />
    </div>
  </ion-content>
  `,
  styles: [`
    .viewer {
      display:flex; align-items:center; justify-content:center;
      height:100%; background: #000;
    }
    img { max-width:100%; max-height:100%; object-fit:contain; }
  `]
})
export class ImageViewerComponent {
  @Input() url!: string;
  constructor(private modal: ModalController) { }
  dismiss() { this.modal.dismiss(); }
}
